import DomainServiceConsole from "containers/DomainServiceConsole";
import { useParams } from "react-router-dom";

const DomainServiceConsolePage = (props) => {
    const { tenant } = useParams();
    return (
        <div className="flex-column-container">
            <div>
                <DomainServiceConsole></DomainServiceConsole>
            </div>
        </div>
    );
};

export default DomainServiceConsolePage;
